// extracted by mini-css-extract-plugin
export default {"shieldLayout":"shield_shieldLayout__sFx-E","arrowBack":"shield_arrowBack__YyLnH","shieldContent":"shield_shieldContent__lUU9X"};